import React from 'react';

const locales = {
	en: {
		Active: 'Active',
		ActiveSubscriptions: "Active subscriptions",
		Add: 'Add',
		AddOrRemoveTenants: 'Add or remove tenants for selected partner to manage',
		AddOrRemovePartnerUsers: 'Add or remove users for selected partner',
		AddPartner: 'Add Partner',
		AddSubscription: 'Add Subscription',
		AddTenant: 'Add tenant',
		AdminConsent: "Admin consent",
		AdminUsers: 'Admin users',
		AdvancedSearchSettings: 'Advanced search settings',
		AdvancedSiteSettings: 'Advanced site settings',
		AllowOpenInSharePoint: 'Allow open in SharePoint',
		Amount: 'Amount',
		ApiKey: 'API key',
		ApprovalStatus: 'Approval status',
		Approved: 'Approved',
		AppLogo: 'App logo',
		AppColor: 'App color',
		AppTitle: 'App title',
		UserContextUsage: 'User context usage',
		AssignedToAnother: 'Tenant assigned to another partner',
		AssignedToYou: 'Tenant is already assigned to you',
		AssignAllLicenses: 'Assign all licenses',
		Attachments: 'Attachments',
		AuthFailed: 'The sign in request could not be completed.',
		AuthKey: 'Authentication key',
		AutoOpenFilterSearchbox: 'Auto open filter search box',
		AuthProcessing: 'Processing sign-in request ...',
		AuthSecret: 'Autentication secret',
		AuthToken: 'Autentication token',
		AutoDeleteMinorVersionsOnPublish: 'Auto delete minor versions on publish',
		AutoFolderCreation: 'Auto folder creation',
		AutoSelectAttachments: 'Auto select attachments',
		AutoRemoveMailItemAttachments: 'Remove attachments from mail item on save',
		Available: 'Available',
		AvailableLicences: 'Available licences',
		AssignedLicences: 'Assigned licences',
		Bcc: 'Bcc',
		Cancel: 'Cancel',
		Canceled: 'Canceled',
		Categories: 'Categories',
		Cc: 'Cc',
		Change: 'Change',
		ClearFilter: "Clear filter",
		ClearSearch: "Clear search",
		ClearSelection: "Clear selection",
		ClickForCalendar: 'Click for Calendar',
		ClientId: "Client Id",
		ClientSecret: "Client Secret",
		Configure: 'Configure',
		Confirm: 'Confirm',
		ConsentSuccessful: "Consent successfully granted.",
		ConsentToApprovalPermissions: "Power Automate",
		ConsentToSharePointPermissions: "SharePoint",
		ConsentToUserPermissions: "User",
		ContentType: 'Content Type',
		ConversationIndex: 'Conversation-index',
		ConversationTopic: 'Conversation-topic',
		ConvertEmailToPdf: 'Convert email to pdf on save',
		Create: 'Create',
		Created: 'Created',
		DataSourceDescription: 'Manage your tenant data sources. Data sources can be set up to create a custom mapping between a data source field, and a SharePoint meta data column.',
		DataSourceFieldName: 'Datasource field name',
		DataSourceFieldNameDuplicate: 'Datasource field name already exists',
		DataSourceName: 'Data source name',
		DatasourceNumber: '{number} datasources connected',
		DataSource: 'Data source',
		DataSources: 'Data sources',
		DataSourceSettings: 'Data source settings',
		Date: 'Date',
		DateRegistered: 'Date registered',
		Deactivated: 'Deactivated',
		Default: 'Default',
		DefaultLicenseType: 'Default user license',
		Delete: 'Delete',
		DeleteWarningMessageDataSource: 'Are you sure you want to delete this datasource?',
		DeleteWarningMessageUsers: 'Are you sure you want to delete the selected user(s)?',
		Description: 'Description',
		Disabled: 'Disabled',
		DisableDocumentRename: 'Disable renaming of documents',
		DisableMailCategorization: "Disable email categorization",
		DisableAutoOpenAfterNewFileFromTemplate: "Disable new template document auto open",
		DisallowedLibraries: 'Disallowed library/list(s) eg. list1; list2',
		DisallowedSites: 'Disallowed site(s) eg. site1; site2',
		Discard: 'Discard',
		DisplayAsDropDown: 'Display as dropdown',
		DisplayName: 'Display name',
		ListGroupPropertyName: "List group property name",
		DocubirdSubscriptionReport: 'Docubird subscription report',
		DocumentLibraries: 'Document libraries',
		DocumentSet: 'Document Set',
		DocumentSettings: 'Document settings',
		Done: 'Done',
		DuplicatesFound: 'Duplicate entries found:',
		DuplicateSitesFound: 'Duplicate site names found:',
		Edit: 'Edit',
		EditDatasource: 'Edit data source',
		EditDatasourceDescription: 'Add, delete, or edit the fields for this data source.\nThe fields shown here show the mapping between a data source value and a SharePoint metadata field.',
		EditDetails: 'Edit details',
		Empty: 'Empty',
		EmailHeaderMapping: 'Email headers mapping',
		Enable: 'Enable',
		Enabled: 'Enabled',
		EnableApprovals: 'Enable approvals center',
		EnableCopyMoveTo: 'Enable copy/move to',
		EnablePermissionManagent: 'Enable management of site/library permissions',
		EnablePII: 'Enable PII',
		EnablePIIRedaction: 'Enable redaction',
		EnableNewTemplateFilters: 'Enable new template filters',
		EnableQuickFilter: 'Enable quick filter',
		EnableSharing: 'Enable sharing',
		EnterAuthKey: 'Enter authentication key',
		EnterAuthSecret: 'Enter authentication secret',
		EnterNewLibName: 'Enter a new library name',
		EnterNewSiteName: 'Enter a new site name',
		EnterSharepointColumn: 'Enter SharePoint column name',
		EnterUrl: 'Enter URL',
		Error: 'Error',
		ErrorAddingDatasourceMappedField: 'Error adding mapped field. Please try again.',
		Evaluation: 'Evaluation',
		ExchangeSettings: 'Exchange settings',
		Expired: 'Expired',
		ExpiryDate: 'Expiry date',
		ExportToExcel: 'Export to Excel',
		Field: 'field',
		Fields: 'fields',
		FieldName: 'Field name',
		FieldToDisplay: 'Enter field to display',
		FieldShown: '{number} {fieldOrSite} shown',
		FieldsShown: '{number} {fieldOrSite} shown',
		FieldHidden: '{number} {fieldOrSite} hidden',
		FieldsHidden: '{number} {fieldOrSite} hidden',
		File: 'File',
		Filter: 'Filter',
		FilterDateStepSince: "Since",
		FilterDateStepLast3Months: "In the last 3 months",
		FilterDateStepLast30Days: "In last 30 days",
		FilterDateStepLast7Days: "In last 7 days",
		FilterDateStepSinceYesterday: "Since yesterday",
		FilterDateStepToday: "Today",
		FilterDateStepTomorrow: "Tomorrow",
		FilterDateStepIn7Days: "In 7 days",
		FilterDateStepIn30Days: "In 30 days",
		FilterDateStepIn3Months: "In 3 months",
		FilterDateStepInAYearOrMore: "In a year or more",
		FilterSettings: 'Filter settings',
		FilterUsers: 'Filter users',
		FilterTenants: 'Filter tenants',
		Folder: 'Folder',
		Free: 'Free',
		Frequency: 'Frequency',
		FriendlyName: 'Friendly name',
		From: 'From',
		GeneralSettings: "General settings",
		Hidden: 'Hidden',
		HideAutoPreview: 'Hide auto file preview',
		HideDocumentLibrariesInTeams: "Hide Teams sites document libraries",
		HideTeamsSitesInSharePoint: "Hide Teams sites under SharePoint",
		HideTitleFieldFilter: "Hide title field filter",
		Importance: 'Importance',
		Inactive: 'Inactive',
		InfoTypesSelected: 'info types selected',
		InReplyTo: 'In reply to',
		InsideDocumentLibrary: 'Inside document library',
		InsideFolder: 'Inside folder',
		InsideDocumentSet: 'Inside document set',
		Integrations: "Integrations",
		InvalidUrl: "Invalid url value",
		Invoice: 'Invoice',
		InvoiceStatic: 'Invoice',
		InvoiceDynamic: 'Invoice dynamic',
		Manage: 'Manage',
		ManageAdvancedSearchFields: 'Manage advanced search fields to display',
		ManageDatasources: 'Manage tenant data sources',
		ManageTeamsFields: 'Manage teams to display',
		ManageSites: 'Manage sites to display',
		ManageSitesPanelInfo: 'Add, remove, or edit tenant sites',
		ManageLibraries: 'Manage libraries',
		ManageMetaData: 'Manage metadata fields to hide',
		ManagedTenants: 'Managed tenants',
		ManageSubscription: 'Manage subscription',
		MappedFields: 'Mapped fields',
		MessageId: 'Message-Id',
		MetadataColorsEdit: "Edit metadata colours",
		MetaDataColorPicker: "Metadata Color Picker",
		MetadataColorValues: "metadata colour value(s)",
		MetaDataSettings: 'Metadata settings',
		MetaDataValue: "Metadata Value",
		Method: "Method",
		MinimumVersionLimit: 'Minimum version limit',
		MinimumLicenseCharge: "A minimum of {amount} licenses will be charged",
		Monthly: 'Monthly',
		Multiselect: 'Multiselect',
		Name: 'Name',
		New: 'New',
		NewTemplateSettings: 'New template settings',
		None: 'None',
		No: 'No',
		NoAcceptedRequests: 'No accepted requests',
		NoActivityFound: 'No activity found',
		NoEmptyFields: 'Fill in empty fields',
		NoFiltersAvailable: "No filters available",
		NoOptionsAvailable: 'No options available',
		NoPartner: 'No partner assigned',
		NoProduct: 'No product',
		NoPendingRequests: 'No pending requests',
		NoRejectedRequests: 'No rejected requests',
		NoRoleAssigned: 'No role assigned',
		NoTenantAdmins: 'No tenant admins',
		NoTenants: 'No managed tenants',
		NoPartnerUsers: 'No partner users',
		NoSubscriptionsFound: "No subscriptions found",
		NoSubscriptionsInView: "No subscriptions in this view",
		NoTenantSelected: 'No tenant selected',
		NotEnoughLicensesAvailable: 'Not enough licenses available. {needed} users need a license, but only {available} are available.',
		NumberOfUsers: 'Number of users',
		OcrSettings: 'OCR settings',
		OcrLanguage: 'OCR language',
		Ok: 'Ok',
		OnceOff: 'Once off',
		OpenDocumentsInClientApp: 'Open supporting documents in client application',
		OriginalSubject: 'Original subject',
		OutlookSettings: 'Outlook settings',
		Overview: 'Overview',
		OverwriteUserEmailMappings: "Do you want to overwrite all user email mappings?",
		OverwriteUsers: "Overwrite users",
		LandingPage: "Landing page",
		LastActivity: 'Last activity',
		LastActivityNone: '-',
		LibraryPanelSubtitle: 'Add, remove, or edit site libraries',
		LicenseExpiryDate: 'License expiry date',
		LicenseType: 'License type',
		LicenseCount: 'License count',
		ListName: 'List name',
		LoadingPortal: 'Loading Docubird Portal...',
		LoadingFilters: "Loading filters",
		Paid: 'Paid',
		Payments: 'Payments',
		PaymentMethod: 'Payment method',
		PaymentPlatform: 'Payment platform',
		Partner: 'Partner',
		Partners: 'Partners',
		PartnerUsers: 'Partner users',
		Pending: 'Pending',
		PermissionSettings: 'Permission settings',
		PIISettings: 'PII settings',
		PickColor: 'Pick color',
		Product: 'Product',
		ProductType: 'Product type',
		Profile: 'Profile',
		PricePerLicenseMonth: "Monthly - €{price}/user/month",
		PricePerLicenseYear: "Annually - €{price}/user/month",
		Received: 'Received',
		References: 'References',
		Refresh: 'Refresh',
		Regenerate: 'Regenerate',
		RegenerateApiKeyWarning: 'Are you sure you want to generate a new API key? This action is irreversible.',
		Remove: 'Remove',
		Rejected: 'Rejected',
		ReplyTo: 'Reply to',
		RequiredMetadataOnPublish: 'Required metadata on publish',
		Requests: 'Requests',
		RequestDate: 'Request date',
		RequestTenant: 'Request tenant',
		RequestingPartner: 'Requesting partner',
		Reset: "Reset",
		RestrictToLibraries: 'Restrict to library/list(s) eg. list1; list2',
		RestrictToSites: 'Restrict to site(s) eg. site1; site2',
		Resume: 'Resume',
		RevokeLicenses: 'Revoke licenses',
		Role: 'Role',
		Save: 'Save',
		SaveChanges: 'Save changes',
		SaveOnSend: 'Save on send',
		SaveRequest: 'Save request',
		Search: 'Search',
		SearchSectionFilter: "Search {section} filters",
		SelectDatasourceField: 'Select datasource field',
		SelectDatasourceType: 'Select a data source type',
		SelectPartner: 'Select a partner to manage this tenant',
		SelectTenantAdmin: 'Select tenant admins',
		SelectTenant: 'Select tenant',
		SetAsPartner: 'Set user as partner',
		SelectPiiInfoTypes: 'Select PII info types',
		SelectSpecificDates: "Select specific dates",
		SelectSubscription: "Select subscription",
		Selected: 'selected',
		SelectPaymentMethod: 'Select payment method',
		SelectWebHookTopic: 'Select service/topic',
		SetAsTenantAdmin: 'Set user as tenant admin',
		Show: 'Show',
		ShowDateRangeSlider: "Show date range slider",
		ShowLess: "Show less",
		ShowMore: "Show more",
		ShowAllFields: 'Show all fields',
		ShowAllTeams: 'Show all teams',
		ShowAllSites: 'Show all sites',
		ShowAllMetadata: 'Show all metadata fields',
		ShowAllTemplates: 'Show all templates',
		ShowAll: 'Show all',
		ShowSelected: 'Show selected',
		SignInDifferentAccount: 'Sign in with a different account',
		SignInRequest: 'Processing sign-in request...',
		SignedInUser: 'Signed-in user: ',
		SignedOutMessage: 'You have successfully signed out of the Docubird Portal application.',
		SignOut: 'Sign out',
		Site: 'site',
		Sites: 'sites',
		SitesLibrariesConfigured: '{siteCount} sites, {libraryCount} libraries configured',
		SiteName: 'Site name',
		SiteSettings: 'Site settings',
		SiteUrl: 'Site URL',
		SharepointColumnName: 'SharePoint column name(s) eg. col1, col2',
		Status: 'Status',
		Subject: 'Subject',
		Subscription: 'Subscription',
		SubscriptionAssignmentFailed: 'The subscription assignment could not be saved. Please refresh and try again.',
		Subscriptions: 'Subscriptions',
		SubscriptionTier: 'Subscription tier',
		SubscriptionType: 'Subscription type',
		SubscriptionUnavailable: 'This subscription is no longer available for assignment.',
		SubscriptionViewAll: 'All',
		SubscriptionViewArchived: 'Archived',
		SubscriptionViewCurrent: 'Current',
		Success: 'Success',
		Suspend: 'Suspend',
		TeamName: 'Team name',
		TeamSettings: 'Teams settings',
		Tenant: 'Tenant',
		Tenants: 'Tenants',
		TenantAdmin: 'Tenant admin',
		TenantId: 'Tenant ID',
		TenantRequestSuccess: 'Successfully requested to manage a tenant',
		Title: 'Title',
		TitleRequired: 'Title required',
		To: 'To',
		TotalRegistrations: 'Total registrations',
		TryAgain: 'Try again',
		Type: 'Type',
		Unassigned: "Unassigned",
		UnauthorizedMessage: 'You are not authorized to access the Docubird Portal application.',
		Unlimited: 'Unlimited',
		ServiceAddOn: 'Service add-on',
		ServiceProductNotAssignable: 'Service add-ons cannot be assigned to users.',
		Url: 'URL',
		User: 'User',
		UserActivity: 'User activity',
		Username: 'Username',
		Users: 'Users',
		VersionSettings: 'Version settings',
		WebHookTopic: "Service/Topic to subscribe to",
		WebHookEventProcessEndpoint: "Process endpoint (url)",
		Yearly: 'Yearly',
		Yes: 'Yes',
		CancelSubscription: 'Cancel subscription',
		CancelSubscriptionConfirmTitle: 'Cancel subscription?',
		CancelSubscriptionConfirmMessage: 'Are you sure you want to cancel the selected subscription(s)?',
		CancelStripeSubscriptionMessage: 'This Stripe subscription will remain active until {expiry}. After that, it will not renew and access ends. Users assigned to the subscription keep access until the period ends. You can resume the subscription before then by re-subscribing through the Stripe Customer Portal.',
		CurrentPeriodEnd: 'the current period end',
		ReactivateSubscription: 'Reactivate subscription',
		ReactivateSubscriptionConfirmTitle: 'Reactivate subscription?',
		ReactivateStripeSubscriptionMessage: 'This subscription is scheduled to cancel on {expiry}. Reactivating it cancels the pending cancellation and the subscription will continue to renew normally.',
		ChangeQuantity: 'Change quantity',
		ChangeQuantityDescription: 'Update the number of seats for this subscription. Current count: {current}.',
		NewSeatCount: 'New seat count',
		QuantityMustBePositive: 'Quantity must be a whole number of 1 or more.',
		QuantityChangeSubmitted: 'Quantity change submitted. The seat count will update once Stripe confirms.',
		ProrateImmediately: 'Bill the prorated difference now',
		ProrateImmediatelyDescription: 'If unchecked, the change will be applied at the next renewal instead.',
		ManageInStripe: 'Manage in Stripe',
		Close: 'Close',
		PendingStripeConfirmation: 'Pending: {count}',
		PendingStripeConfirmationTooltip: 'Stripe quantity change submitted. The seat count will update once Stripe confirms (usually within a few seconds).',
		DuplicateActiveSubscriptionWarning: 'This tenant already has an active subscription for the selected product. Continuing will create a second, independent subscription with its own billing cycle. Click Add Subscription to confirm.',
		UnexpectedError: 'An unexpected error occurred. Please try again.',
		CurrentlyAssignedUsers: 'Currently assigned: {count} user(s)',
		QuantityNoChangeMessage: 'No quantity change selected. Billing and assignments remain unchanged.',
		AutoRevokeMessage: '{count} user(s) with the oldest activity will be automatically revoked from this subscription when Stripe confirms.',
		NoUsersRevokedMessage: 'No users will be revoked — the new seat count still covers all currently assigned users.',
		AutoAssignMessage: 'Up to {count} new seat(s) will be auto-assigned to the most-recently-active eligible users in this tenant when Stripe confirms.',
		PreviewLoading: 'Calculating estimated cost…',
		PreviewUnavailable: 'Cost estimate is currently unavailable.',
		PreviewCurrentInvoice: 'Current upcoming invoice total: {amount}',
		PreviewProrationDelta: 'Prorated charge now: {amount}',
		PreviewProrationCredit: 'Prorated credit now: {amount}',
		PreviewProrationNone: 'No prorated charge — change applies at next renewal.',
		PreviewUpcomingInvoice: 'Upcoming invoice total: {amount}',
		SubscriptionHistory: 'Subscription history',
		NoSubscriptionHistory: 'No history yet.',
		SubscriptionHistoryLoadFailed: 'Failed to load subscription history.',
		SubscriptionPayments: 'Subscription payments',
		NoSubscriptionPayments: 'No payments yet.',
		SubscriptionPaymentsLoadFailed: 'Failed to load payments.',
		ViewInvoice: 'View invoice',
		DownloadInvoicePdf: 'Download PDF',
		LoadMore: 'Load more',
		Loading: 'Loading...',
		HideDetails: 'Hide details',
		ShowDetails: 'Show details',
		OldValues: 'Old',
		NewValues: 'New',
		Details: 'Details',
		OrphanCustomers: 'Orphan customers',
		OrphanCustomersDescription: 'Stripe customers whose webhook events could not be matched to a Docubird tenant. Adopt one to a tenant to stamp metadata and replay the stuck events.',
		NoOrphans: 'No orphan customers — webhook tenant resolution is healthy.',
		AdoptCustomer: 'Adopt customer',
		AdoptOrphanCustomerTitle: 'Adopt orphan customer',
		PickTenant: 'Pick tenant',
		PickTenantPlaceholder: 'Select the tenant this customer belongs to',
		AdoptOrphanWarning: 'This will stamp tenantGuid on the Stripe customer and its subscriptions, then replay the stuck webhook events. Make sure the email and product list match the picked tenant.',
		AdoptAndReprocess: 'Adopt & reprocess',
		OrphanAdopted: 'Customer adopted. The stuck events have been re-queued.',
		StuckEvents: 'Stuck events',
		StuckSubscriptions: 'Stripe subscriptions',
		CustomerDeleted: 'Customer was deleted in Stripe',
		HasTenantGuidStamped: 'Already has tenantGuid metadata',
		StripeCustomerId: 'Stripe customer id',
		StripeSubscriptionId: 'Stripe subscription id',
		OldestEvent: 'Oldest event',
		TotalAmount: 'Total amount',
		UnresolvedDeadLetteredEvents: 'Unresolved dead-lettered events (no customer reference)',
		OrphanToolbarButton: 'Orphans',
		OrphanBannerSingular: 'A Stripe customer could not be linked to a Docubird tenant.',
		OrphanBannerPlural: '{count} Stripe customers could not be linked to a Docubird tenant.',
		Review: 'Review',
		CancelsOn: 'Cancels {date}',
		ManageStripeProducts: 'Manage Stripe products',
		AddProduct: 'Add product',
		EditProduct: 'Edit product',
		SyncFromStripe: 'Sync from Stripe',
	},
	nl: {
		Active: 'Actief',
		ActiveSubscriptions: "Actieve abonnementen",
		Add: 'Toevoegen',
		AddOrRemoveTenants: 'Tenants toevoegen of verwijderen voor geselecteerde partner om te beheren',
		AddOrRemovePartnerUsers: 'Gebruikers toevoegen of verwijderen voor geselecteerde partner',
		AddPartner: 'Partner toevoegen',
		AddSubscription: 'Abonnement toevoegen',
		AddTenant: 'Tenant toevoegen',
		AdminConsent: "Beheerderstoestemming",
		AdminUsers: 'Admin gebruikers',
		AdvancedSearchSettings: 'Geavanceerde zoekinstellingen',
		AdvancedSiteSettings: 'Geavanceerde site-instellingen',
		AllowOpenInSharePoint: 'Openen in SharePoint toestaan',
		Amount: 'Bedrag',
		ApiKey: 'API sleutel',
		ApprovalStatus: 'Goedkeuringsstatus',
		Approved: 'Goedgekeurd',
		AppLogo: 'App logo',
		AppColor: 'App kleur',
		AppTitle: 'App titel',
		UserContextUsage: 'Gebruikerscontextgebruik',
		AssignedToAnother: 'Tenant toegewezen aan een andere partner',
		AssignedToYou: 'Tenant is al aan u toegewezen',
		AssignAllLicenses: 'Alle licenties toewijzen',
		Attachments: 'Bijlagen',
		AuthFailed: 'Het aanmeldingsverzoek kan niet worden voltooid.',
		AuthKey: 'Verificatiesleutel',
		AutoOpenFilterSearchbox: 'Automatisch openen van filterzoekvak',
		AuthProcessing: 'Aanmeldingsverzoek verwerken ...',
		AuthSecret: 'Authenticatiegeheim',
		AuthToken: 'Autenticatietoken',
		AutoDeleteMinorVersionsOnPublish: 'Kleine versies automatisch verwijderen bij publicatie',
		AutoFolderCreation: 'Automatische map',
		AutoSelectAttachments: 'Bijlagen automatisch selecteren',
		AutoRemoveMailItemAttachments: 'Verwijder bijlagen van e-mailitem bij opslaan',
		Available: 'Beschikbaar',
		AvailableLicences: 'Beschikbare licenties',
		AssignedLicences: 'Toegewezen licenties',
		Bcc: 'Bcc',
		Cancel: 'Annuleer',
		Canceled: 'Geannuleerd',
		Categories: 'Categorieën',
		Cc: 'Cc',
		Change: 'Verander',
		ClearFilter: "Filter wissen",
		ClearSearch: "Zoekactie verwijderen",
		ClearSelection: "Selectie wissen",
		ClickForCalendar: 'Klik voor kalender',
		ClientId: "Client-ID",
		ClientSecret: "Clientgeheim",
		Configure: 'Configureer',
		Confirm: 'Bevestig',
		ConsentSuccessful: "Toestemming succesvol verleend.",
		ConsentToApprovalPermissions: "Power Automate",
		ConsentToSharePointPermissions: "SharePoint",
		ConsentToUserPermissions: "Gebruiker",
		ContentType: 'Inhoudstype',
		ConversationIndex: 'Conversatie-index',
		ConversationTopic: 'Conversatie-onderwerp',
		ConvertEmailToPdf: 'E-mail converteren naar pdf bij opslaan',
		Create: 'Aanmaken',
		Created: 'Aangemaakt',
		DataSourceDescription: 'Beheer uw gegevensbronnen voor huurders. Gegevensbronnen kunnen worden ingesteld om een ​​aangepaste toewijzing te maken tussen een gegevensbronveld en een SharePoint-metagegevenskolom.',
		DataSourceFieldName: 'Gegevensbron veldnaam',
		DataSourceFieldNameDuplicate: 'De naam van het gegevensbronveld bestaat al',
		DataSourceName: 'Naam gegevensbron',
		DatasourceNumber: '{number} databronnen verbonden',
		DataSource: 'Data bron',
		DataSources: 'Data bronnen',
		DocumentSet: 'Documentenset',
		DataSourceSettings: 'Instellingen gegevensbron',
		Date: 'Datum',
		DateRegistered: 'Datum geregistreerd',
		Deactivated: 'Gedeactiveerd',
		Default: 'Standaard',
		DefaultLicenseType: 'Standaard gebruiker licentie',
		Delete: 'Verwijderen',
		DeleteWarningMessageDataSource: 'Weet u zeker dat u deze gegevensbron wilt verwijderen?',
		DeleteWarningMessageUsers: 'Weet je zeker dat je de geselecteerde gebruiker(s) wilt verwijderen?',
		Description: 'Beschrijving',
		Disabled: 'Uitgeschakeld',
		DisableDocumentRename: 'Hernoemen van documenten uitschakelen',
		DisableMailCategorization: "Uitschakelen van e-mailcategorisering",
		DisableAutoOpenAfterNewFileFromTemplate: "Automatisch openen van nieuw sjabloondocument uitschakelen",
		DisallowedLibraries: 'Niet toegestane bibliotheek/lijst(en), bijv. lijst1; lijst2',
		DisallowedSites: 'Niet toegestane site(s) bijv. site1; site2',
		Discard: 'Afleggen',
		DisplayAsDropDown: 'Weergeven als vervolgkeuzelijst',
		DisplayName: 'Weergavenaam',
		ListGroupPropertyName: "Lijst groep-eigenschapsnaam",
		DocubirdSubscriptionReport: 'Docubird abonnementsverslag',
		DocumentLibraries: 'Documentbibliotheken',
		DocumentSettings: 'Document-instellingen',
		Done: 'Klaar',
		DuplicatesFound: 'Dubbele vermeldingen gevonden:',
		DuplicateSitesFound: 'Dubbele sitenamen gevonden:',
		Edit: 'Bewerk',
		EditDatasource: 'Gegevensbron bewerken',
		EditDatasourceDescription: 'Voeg de velden voor deze gegevensbron toe, verwijder of bewerk deze.\nDe velden die hier worden weergegeven, tonen de toewijzing tussen een gegevensbronwaarde en een SharePoint-metagegevensveld.',
		EditDetails: 'Details bewerken',
		Empty: 'Leeg',
		EmailHeaderMapping: 'Toewijzing van e-mailheaders',
		Enable: 'Inschakelen',
		Enabled: 'Ingeschakeld',
		EnableApprovals: 'Goedkeuringscentrum inschakelen',
		EnableCopyMoveTo: 'Inschakelen kopiëren/verplaatsen naar',
		EnablePermissionManagent: 'Beheer van site/bibliotheek-rechten inschakelen',
		EnablePII: 'PII inschakelen',
		EnablePIIRedaction: 'Redactie inschakelen',
		EnableNewTemplateFilters: 'Nieuwe sjabloonfilters inschakelen',
		EnableQuickFilter: 'Quick filter inschakelen',
		EnableSharing: 'Delen mogelijk maken',
		EnterAuthKey: 'Verificatiesleutel invoeren',
		EnterAuthSecret: 'Voer authenticatiegeheim in',
		EnterNewLibName: 'Voer een nieuwe bibliotheeknaam in',
		EnterNewSiteName: 'Voer een nieuwe sitenaam in',
		EnterSharepointColumn: 'Voer de naam van de SharePoint-kolom in',
		EnterUrl: 'Voer URL in',
		Error: 'Fout',
		ErrorAddingDatasourceMappedField: 'Fout bij het toevoegen van gemapt veld. Probeer het opnieuw.',
		Evaluation: 'Evaluatie',
		ExchangeSettings: 'Exchange-instellingen',
		Expired: 'Vervallen',
		ExpiryDate: 'Vervaldatum',
		ExportToExcel: 'Exporteren naar Excel',
		Field: 'veld',
		Fields: 'velden',
		FieldName: 'Veldnaam',
		FieldToDisplay: 'Veld om weer te geven',
		FieldShown: '{number} {fieldOrSite} getoond',
		FieldsShown: '{number} {fieldOrSite} getoond',
		FieldHidden: '{number} {fieldOrSite} verborgen',
		FieldsHidden: '{number} {fieldOrSite} verborgen',
		File: 'Bestand',
		Filter: 'Filter',
		FilterDateStepSince: "Sinds",
		FilterDateStepLast3Months: "In de afgelopen 3 maanden",
		FilterDateStepLast30Days: "In de afgelopen 30 dagen",
		FilterDateStepLast7Days: "In de afgelopen 7 dagen",
		FilterDateStepSinceYesterday: "Sinds gisteren",
		FilterDateStepToday: "Vandaag",
		FilterDateStepTomorrow: "Morgen",
		FilterDateStepIn7Days: "Over 7 dagen",
		FilterDateStepIn30Days: "Over 30 dagen",
		FilterDateStepIn3Months: "Over 3 maanden",
		FilterDateStepInAYearOrMore: "Over een jaar of langer",
		FilterSettings: 'Filterinstellingen',
		FilterUsers: 'Gebruikers filteren',
		FilterTenants: 'tenants filteren',
		Folder: 'Map',
		Free: 'Gratis',
		Frequency: 'Frequentie',
		FriendlyName: 'Vriendelijke naam',
		From: 'Van',
		GeneralSettings: "Algemene instellingen",
		Hidden: 'Verborgen',
		HideAutoPreview: 'Verberg automatisch bestandsvoorbeelden',
		HideDocumentLibrariesInTeams: "Verberg teamsites documentbibliotheken",
		HideTeamsSitesInSharePoint: "Verberg Teams-sites onder SharePoint",
		HideTitleFieldFilter: "Verberg titelveldfilter",
		Importance: 'Belangrijkheid',
		Inactive: 'Inactief',
		InfoTypesSelected: 'infotypes geselecteerd',
		InReplyTo: 'Als antwoord op',
		InsideDocumentLibrary: 'In de documentenbibliotheek',
		InsideFolder: 'Binnenkant map',
		InsideDocumentSet: 'Binnenkant documentenset',
		Integrations: "Integraties",
		InvalidUrl: "Ongeldige url-waarde",
		Invoice: 'Factuur',
		InvoiceStatic: 'Factuur',
		InvoiceDynamic: 'Dynamische factuur',
		Manage: 'Beheren',
		ManageAdvancedSearchFields: 'Geavanceerde zoekvelden om weer te geven',
		ManageDatasources: 'Gegevensbronnen van huurders beheren',
		ManageTeamsFields: 'Beheer teams om weer te geven',
		ManageSites: 'Sites beheren om weer te geven',
		ManageSitesPanelInfo: 'Sites toevoegen, verwijderen of bewerken',
		ManageLibraries: 'Bibliotheken beheren',
		ManageMetaData: 'Metadatavelden beheren om te verbergen',
		ManagedTenants: 'Beheerde tenants',
		ManageSubscription: 'Abonnement beheren',
		MappedFields: 'Toegewezen velden',
		MessageId: 'E-mailbericht-Id',
		MetadataColorsEdit: "Metagegevenskleuren bewerken",
		MetaDataColorPicker: "Kleurkiezer voor metagegevens",
		MetadataColorValues: "metadata-kleurwaarde(n)",
		MetaDataSettings: 'Metadata-instellingen',
		MetaDataValue: "Metagegevenswaarde",
		Method: "Methode",
		MinimumVersionLimit: 'Minimale versielimiet',
		MinimumLicenseCharge: "Een minimum van {amount} licenties wordt in rekening gebracht",
		Monthly: 'Maandelijks',
		Multiselect: 'Meerkeuze selectie',
		Name: 'Naam',
		New: 'Nieuwe',
		NewTemplateSettings: 'Nieuwe sjablooninstellingen',
		None: 'Geen',
		No: 'Nee',
		NoAcceptedRequests: 'Geen aanvaarde verzoeken',
		NoActivityFound: 'Geen activiteit gevonden',
		NoEmptyFields: 'Vul lege velden in',
		NoFiltersAvailable: "Geen filters beschikbaar",
		NoOptionsAvailable: 'Geen opties beschikbaar',
		NoPartner: 'Geen partner toegewezen',
		NoProduct: 'Geen product',
		NoPendingRequests: 'Geen lopende verzoeken',
		NoRejectedRequests: 'Geen afgewezen verzoeken',
		NoRoleAssigned: 'Geen rol toegewezen',
		NoTenantAdmins: 'Geen tenantbeheerders',
		NoTenants: 'Geen beheerde tenants',
		NoPartnerUsers: 'Geen partnergebruikers',
		NoSubscriptionsFound: "Geen abonnementen gevonden",
		NoSubscriptionsInView: "Geen abonnementen in deze weergave",
		NoTenantSelected: 'Geen tenant geselecteerd',
		NotEnoughLicensesAvailable: 'Niet genoeg licenties beschikbaar. {needed} gebruikers hebben een licentie nodig, maar er zijn er slechts {available} beschikbaar.',
		NumberOfUsers: 'Aantal gebruikers',
		OcrSettings: 'OCR-instellingen',
		OcrLanguage: 'OCR-taal',
		Ok: 'Ok',
		OnceOff: 'Eenmalig',
		OpenDocumentsInClientApp: 'Open ondersteunende documenten in client toepassing',
		OriginalSubject: 'Origineel onderwerp',
		OutlookSettings: 'Outlook-instellingen',
		Overview: 'Overzicht',
		OverwriteUserEmailMappings: "Wilt u alle emailmappings van gebruikers overschrijven?",
		OverwriteUsers: "Gebruikers overschrijven",
		LandingPage: "Landingspagina",
		LastActivity: 'Laatste activiteit',
		LastActivityNone: '-',
		LibraryPanelSubtitle: 'Sitebibliotheken toevoegen, verwijderen of bewerken',
		LicenseExpiryDate: 'Licentie vervaldatum',
		LicenseType: 'Licentie type',
		LicenseCount: 'Aantal licenties',
		ListName: 'Lijstnaam',
		LoadingPortal: 'Docubird portal laden...',
		LoadingFilters: "Filters laden",
		Paid: 'Betaald',
		Payments: 'Betalingen',
		PaymentMethod: 'Betaalmethode',
		PaymentPlatform: 'Betaalplatform',
		Partner: 'Partner',
		Partners: 'Partners',
		PartnerUsers: 'Partner gebruikers',
		Pending: 'In afwachting',
		PermissionSettings: 'Rechten instellingen',
		PIISettings: 'PII-instellingen',
		PickColor: 'Kleur kiezen',
		Product: 'Product',
		ProductType: 'Producttype',
		Profile: 'Profiel',
		PricePerLicenseMonth: "Maandelijks - €{price}/gebruiker/maand",
		PricePerLicenseYear: "Jaarlijks - €{price}/gebruiker/maand",
		Received: 'Ontvangen',
		References: 'Referenties',
		Refresh: 'Vernieuwen',
		Regenerate: 'Regenereren',
		RegenerateApiKeyWarning: 'Weet u zeker dat u een nieuwe API sleutel wilt genereren? Deze actie is onomkeerbaar.',
		Remove: 'Verwijderen',
		Rejected: 'Afgekeurd',
		ReplyTo: 'Antwoord aan',
		RequiredMetadataOnPublish: 'Vereiste metadata bij publicatie',
		Requests: 'Verzoeken',
		RequestDate: 'Aanvraagdatum',
		RequestTenant: 'Verzoek tenant',
		RequestingPartner: 'Verzoekende partner',
		Reset: "Annuleren",
		RestrictToLibraries: 'Beperken tot bibliotheek/lijst(en) bijv. lijst; lijst2',
		RestrictToSites: 'Beperken tot site(s) bijv. site1; site2',
		Resume: 'Hervatten',
		RevokeLicenses: 'Licenties intrekken',
		Role: 'Rol',
		Save: 'Opslaan',
		SaveChanges: 'Wijzigingen opslaan',
		SaveOnSend: 'Opslaan na sturen',
		SaveRequest: 'Verzoek opslaan',
		Search: 'Zoeken',
		SearchSectionFilter: "Zoek {section} filters",
		SelectDatasourceField: 'Selecteer gegevensbronveld',
		SelectDatasourceType: 'Selecteer een gegevensbrontype',
		SelectPartner: 'Selecteer een partner om deze tenant te beheren',
		SelectTenantAdmin: 'Selecteer tenantbeheerders',
		SelectTenant: 'Selecteer tenant',
		SetAsPartner: 'Stel de gebruiker in als partner',
		SelectPiiInfoTypes: 'Selecteer PII-infotypes',
		SelectSpecificDates: "Specifieke datums selecteren",
		SelectSubscription: "Selecteer abonnement",
		SelectPaymentMethod: 'Selecteer betaalmethode',
		SelectWebHookTopic: 'Selecteer service/onderwerp',
		SetAsTenantAdmin: 'Stel de gebruiker in als tenantbeheerder',
		SignInDifferentAccount: 'Login met een ander account',
		SignInRequest: 'Het inlogverzoek verwerken...',
		SignedInUser: 'Aangemelde gebruiker: ',
		SignedOutMessage: 'U heeft zich met succes afgemeld bij de Docubird Portal-applicatie.',
		SignOut: 'Afmelden',
		Site: 'site',
		Sites: 'sites',
		SitesLibrariesConfigured: '{siteCount} sites, {libraryCount} bibliotheken geconfigureerd',
		SiteName: 'Site naam',
		SiteSettings: 'Site-instellingen',
		SiteUrl: 'Site-URL',
		SharepointColumnName: 'SharePoint-kolomnaam(-namen) bijv. col1, col2',
		Selected: 'geselecteerd',
		Show: 'Toon',
		ShowDateRangeSlider: "Toon datumbereik schuif",
		ShowLess: "Laat minder zien",
		ShowMore: "Laat meer zien",
		ShowAllFields: 'Toon alle velden',
		ShowAllTeams: 'Toon alle teams',
		ShowAllSites: 'Toon alle sites',
		ShowAllMetadata: 'Toon alle metadata velden',
		ShowAllTemplates: 'Toon alle sjablonen',
		ShowAll: 'Toon alles',
		ShowSelected: 'Geselecteerde tonen',
		Status: 'Status',
		Subject: 'Onderwerp',
		Subscription: 'Abonnement',
		SubscriptionAssignmentFailed: 'De abonnementstoewijzing kon niet worden opgeslagen. Vernieuw en probeer het opnieuw.',
		Subscriptions: 'Abonnementen',
		SubscriptionTier: 'Abonnementsniveau',
		SubscriptionType: 'Type abonnement',
		SubscriptionUnavailable: 'Dit abonnement is niet meer beschikbaar voor toewijzing.',
		SubscriptionViewAll: 'Alle',
		SubscriptionViewArchived: 'Gearchiveerd',
		SubscriptionViewCurrent: 'Huidig',
		Success: 'Succes',
		Suspend: 'Opschorten',
		TeamName: 'Teamnaam',
		TeamSettings: 'Teams-instellingen',
		Tenant: 'Tenant',
		Tenants: 'Tenants',
		TenantAdmin: 'Tenantbeheerder',
		TenantId: 'Tenant ID',
		TenantRequestSuccess: 'Met succes aangevraagd om een tenant te beheren',
		Title: 'Titel',
		TitleRequired: 'Titel vereist',
		To: 'Aan',
		TotalRegistrations: 'Totaal aantal inschrijvingen',
		TryAgain: 'Probeer het opnieuw',
		Type: 'Type',
		Unassigned: "Niet toegewezen",
		UnauthorizedMessage: 'U heeft geen toegang tot de Docubird Portal-applicatie.',
		Unlimited: 'Onbeperkt',
		ServiceAddOn: 'Service-add-on',
		ServiceProductNotAssignable: 'Service-add-ons kunnen niet aan gebruikers worden toegewezen.',
		Url: 'URL',
		User: 'Gebruiker',
		UserActivity: 'Gebruikersactiviteit',
		Username: 'Gebruikersnaam',
		Users: 'Gebruikers',
		VersionSettings: 'Versie-instellingen',
		WebHookTopic: "Service/Onderwerp om op te abonneren",
		WebHookEventProcessEndpoint: "Proces-eindpunt (url)",
		Yearly: 'Jaarlijks',
		Yes: 'Ja',
		CancelSubscription: 'Abonnement opzeggen',
		CancelSubscriptionConfirmTitle: 'Abonnement opzeggen?',
		CancelSubscriptionConfirmMessage: 'Weet u zeker dat u het/de geselecteerde abonnement(en) wilt opzeggen?',
		CancelStripeSubscriptionMessage: 'Dit Stripe-abonnement blijft actief tot {expiry}. Daarna wordt het niet meer verlengd en eindigt de toegang. Gebruikers met een toegewezen licentie behouden toegang tot het einde van de periode. U kunt het abonnement vóór die tijd hervatten door opnieuw in te schrijven via het Stripe-klantenportaal.',
		CurrentPeriodEnd: 'het einde van de huidige periode',
		ReactivateSubscription: 'Abonnement opnieuw activeren',
		ReactivateSubscriptionConfirmTitle: 'Abonnement opnieuw activeren?',
		ReactivateStripeSubscriptionMessage: 'Dit abonnement is gepland om te worden opgezegd op {expiry}. Door het opnieuw te activeren wordt de geplande opzegging geannuleerd en wordt het abonnement normaal verlengd.',
		ChangeQuantity: 'Aantal wijzigen',
		ChangeQuantityDescription: 'Werk het aantal licenties voor dit abonnement bij. Huidig aantal: {current}.',
		NewSeatCount: 'Nieuw aantal licenties',
		QuantityMustBePositive: 'Aantal moet een geheel getal van 1 of hoger zijn.',
		QuantityChangeSubmitted: 'Wijziging van het aantal is ingediend. Het licentieaantal wordt bijgewerkt zodra Stripe dit bevestigt.',
		ProrateImmediately: 'Het verschil nu naar rato in rekening brengen',
		ProrateImmediatelyDescription: 'Als dit is uitgeschakeld, wordt de wijziging pas bij de volgende verlenging toegepast.',
		ManageInStripe: 'Beheren in Stripe',
		Close: 'Sluiten',
		PendingStripeConfirmation: 'In behandeling: {count}',
		PendingStripeConfirmationTooltip: 'Wijziging van het Stripe-aantal is ingediend. Het licentieaantal wordt bijgewerkt zodra Stripe dit bevestigt (meestal binnen enkele seconden).',
		DuplicateActiveSubscriptionWarning: 'Deze tenant heeft al een actief abonnement voor het geselecteerde product. Doorgaan maakt een tweede, onafhankelijk abonnement met een eigen factureringscyclus aan. Klik op Abonnement toevoegen om te bevestigen.',
		UnexpectedError: 'Er is een onverwachte fout opgetreden. Probeer het opnieuw.',
		CurrentlyAssignedUsers: 'Momenteel toegewezen: {count} gebruiker(s)',
		QuantityNoChangeMessage: 'Geen wijziging geselecteerd. Facturering en toewijzingen blijven ongewijzigd.',
		AutoRevokeMessage: '{count} gebruiker(s) met de oudste activiteit worden automatisch ingetrokken van dit abonnement zodra Stripe bevestigt.',
		NoUsersRevokedMessage: 'Er worden geen gebruikers ingetrokken — het nieuwe aantal licenties dekt nog steeds alle toegewezen gebruikers.',
		AutoAssignMessage: 'Maximaal {count} nieuwe licentie(s) worden automatisch toegewezen aan de meest recent actieve in aanmerking komende gebruikers in deze tenant zodra Stripe bevestigt.',
		PreviewLoading: 'Geschatte kosten berekenen…',
		PreviewUnavailable: 'Kostenraming is momenteel niet beschikbaar.',
		PreviewCurrentInvoice: 'Huidig totaal van de volgende factuur: {amount}',
		PreviewProrationDelta: 'Pro rata kosten nu: {amount}',
		PreviewProrationCredit: 'Pro rata tegoed nu: {amount}',
		PreviewProrationNone: 'Geen pro rata kosten — wijziging gaat in bij de volgende verlenging.',
		PreviewUpcomingInvoice: 'Totaal van de volgende factuur: {amount}',
		SubscriptionHistory: 'Abonnementsgeschiedenis',
		NoSubscriptionHistory: 'Nog geen geschiedenis.',
		SubscriptionHistoryLoadFailed: 'Geschiedenis kon niet worden geladen.',
		SubscriptionPayments: 'Betalingen voor abonnement',
		NoSubscriptionPayments: 'Nog geen betalingen.',
		SubscriptionPaymentsLoadFailed: 'Betalingen konden niet worden geladen.',
		ViewInvoice: 'Factuur bekijken',
		DownloadInvoicePdf: 'PDF downloaden',
		LoadMore: 'Meer laden',
		Loading: 'Bezig met laden...',
		HideDetails: 'Details verbergen',
		ShowDetails: 'Details tonen',
		OldValues: 'Oud',
		NewValues: 'Nieuw',
		Details: 'Details',
		OrphanCustomers: 'Wees-klanten',
		OrphanCustomersDescription: 'Stripe-klanten waarvan de webhook-events niet aan een Docubird-tenant konden worden gekoppeld. Adopteer ze om metadata te stempelen en de vastgelopen events opnieuw te verwerken.',
		NoOrphans: 'Geen wees-klanten — webhook tenant-resolutie is gezond.',
		AdoptCustomer: 'Klant adopteren',
		AdoptOrphanCustomerTitle: 'Wees-klant adopteren',
		PickTenant: 'Tenant kiezen',
		PickTenantPlaceholder: 'Selecteer de tenant waar deze klant bij hoort',
		AdoptOrphanWarning: 'Dit zet tenantGuid op de Stripe-klant en bijbehorende subscriptions, en verwerkt vervolgens de vastgelopen webhook-events opnieuw. Controleer of het e-mailadres en het productenoverzicht overeenkomen met de gekozen tenant.',
		AdoptAndReprocess: 'Adopteren & opnieuw verwerken',
		OrphanAdopted: 'Klant geadopteerd. De vastgelopen events worden opnieuw verwerkt.',
		StuckEvents: 'Vastgelopen events',
		StuckSubscriptions: 'Stripe-subscriptions',
		CustomerDeleted: 'Klant is in Stripe verwijderd',
		HasTenantGuidStamped: 'Heeft al tenantGuid-metadata',
		StripeCustomerId: 'Stripe klant-id',
		StripeSubscriptionId: 'Stripe subscription-id',
		OldestEvent: 'Oudste event',
		TotalAmount: 'Totaalbedrag',
		UnresolvedDeadLetteredEvents: 'Onopgeloste dead-lettered events (geen klantreferentie)',
		OrphanToolbarButton: 'Wees-klanten',
		OrphanBannerSingular: 'Een Stripe-klant kon niet aan een Docubird-tenant worden gekoppeld.',
		OrphanBannerPlural: '{count} Stripe-klanten konden niet aan een Docubird-tenant worden gekoppeld.',
		Review: 'Bekijken',
		CancelsOn: 'Stopt {date}',
		ManageStripeProducts: 'Stripe-producten beheren',
		AddProduct: 'Product toevoegen',
		EditProduct: 'Product bewerken',
		SyncFromStripe: 'Synchroniseren vanuit Stripe',
	},
	de: {
		Active: 'Aktiv',
		ActiveSubscriptions: "Aktive Abonnements",
		Add: 'Hinzufügen',
		AddOrRemoveTenants: 'Mandanten für den ausgewählten Partner hinzufügen oder entfernen',
		AddOrRemovePartnerUsers: 'Benutzer für den ausgewählten Partner hinzufügen oder entfernen',
		AddPartner: 'Partner hinzufügen',
		AddSubscription: 'Abonnement hinzufügen',
		AddTenant: 'Mandant hinzufügen',
		AdminConsent: "Administratorzustimmung",
		AdminUsers: 'Administratoren',
		AdvancedSearchSettings: 'Erweiterte Sucheinstellungen',
		AdvancedSiteSettings: 'Erweiterte Seiteneinstellungen',
		AllowOpenInSharePoint: 'Öffnen in SharePoint erlauben',
		Amount: 'Betrag',
		ApiKey: 'API-Schlüssel',
		ApprovalStatus: 'Genehmigungsstatus',
		Approved: 'Genehmigt',
		AppLogo: 'App-Logo',
		AppColor: 'App-Farbe',
		AppTitle: 'App-Titel',
		UserContextUsage: 'Benutzerkontextnutzung',
		AssignedToAnother: 'Mandant einem anderen Partner zugewiesen',
		AssignedToYou: 'Mandant ist bereits Ihnen zugewiesen',
		AssignAllLicenses: 'Alle Lizenzen zuweisen',
		Attachments: 'Anhänge',
		AuthFailed: 'Die Anmeldung konnte nicht abgeschlossen werden.',
		AuthKey: 'Authentifizierungsschlüssel',
		AutoOpenFilterSearchbox: 'Filter-Suchfeld automatisch öffnen',
		AuthProcessing: 'Anfrage zur Anmeldung wird verarbeitet...',
		AuthSecret: 'Authentifizierungsgeheimnis',
		AuthToken: 'Authentifizierungstoken',
		AutoDeleteMinorVersionsOnPublish: 'Automatisches Löschen kleiner Versionen bei Veröffentlichung',
		AutoFolderCreation: 'Automatische Ordnererstellung',
		AutoSelectAttachments: 'Anhänge automatisch auswählen',
		AutoRemoveMailItemAttachments: 'Anhänge von E-Mail-Elementen beim Speichern entfernen',
		Available: 'Verfügbar',
		AvailableLicences: 'Verfügbare Lizenzen',
		AssignedLicences: 'Zugewiesene Lizenzen',
		Bcc: 'Bcc',
		Cancel: 'Abbrechen',
		Canceled: 'Abgebrochen',
		Categories: 'Kategorien',
		Cc: 'Cc',
		Change: 'Ändern',
		ClearFilter: "Filter löschen",
		ClearSearch: "Suche löschen",
		ClearSelection: "Auswahl löschen",
		ClickForCalendar: 'Klicken für Kalender',
		ClientId: "Client-ID",
		ClientSecret: "Client-Geheimnis",
		Configure: 'Konfigurieren',
		Confirm: 'Bestätigen',
		ConsentSuccessful: "Zustimmung erfolgreich erteilt.",
		ConsentToApprovalPermissions: "Power Automate",
		ConsentToSharePointPermissions: "SharePoint",
		ConsentToUserPermissions: "Benutzer",
		ContentType: 'Inhaltstyp',
		ConversationIndex: 'Konversationsindex',
		ConversationTopic: 'Konversationsthema',
		ConvertEmailToPdf: 'E-Mail beim Speichern in PDF konvertieren',
		Create: 'Erstellen',
		Created: 'Erstellt',
		DataSourceDescription: 'Verwalten Sie Ihre Mandanten-Datenquellen. Datenquellen können eingerichtet werden, um eine benutzerdefinierte Zuordnung zwischen einem Datenquellenfeld und einer SharePoint-Metadatenspalte zu erstellen.',
		DataSourceFieldName: 'Datenquellenfeldname',
		DataSourceFieldNameDuplicate: 'Datenquellenfeldname existiert bereits',
		DataSourceName: 'Datenquellenname',
		DatasourceNumber: '{number} Datenquellen verbunden',
		DataSource: 'Datenquelle',
		DataSources: 'Datenquellen',
		DataSourceSettings: 'Datenquelleneinstellungen',
		Date: 'Datum',
		DateRegistered: 'Registrierungsdatum',
		Deactivated: 'Deaktiviert',
		Default: 'Standard',
		DefaultLicenseType: 'Standardbenutzerlizenz',
		Delete: 'Löschen',
		DeleteWarningMessageDataSource: 'Möchten Sie diese Datenquelle wirklich löschen?',
		DeleteWarningMessageUsers: 'Möchten Sie den/die ausgewählten Benutzer wirklich löschen?',
		Description: 'Beschreibung',
		Disabled: 'Deaktiviert',
		DisableDocumentRename: 'Dokumentenumbennung deaktivieren',
		DisableMailCategorization: "E-Mail-Kategorisierung deaktivieren",
		DisableAutoOpenAfterNewFileFromTemplate: "Automatisches Öffnen neuer Vorlagendokumente deaktivieren",
		DisallowedLibraries: 'Nicht zugelassene Bibliothek/Liste(n), z. B. Liste1; Liste2',
		DisallowedSites: 'Nicht zugelassene Site(s), z. B. Site1; Site2',
		Discard: 'Verwerfen',
		DisplayAsDropDown: 'Als Dropdown anzeigen',
		DisplayName: 'Anzeigename',
		ListGroupPropertyName: "Name der Listengruppeneigenschaft",
		DocubirdSubscriptionReport: 'Docubird-Abonnementbericht',
		DocumentLibraries: 'Dokumentbibliotheken',
		DocumentSet: 'Dokumentenset',
		DocumentSettings: 'Dokumenteinstellungen',
		Done: 'Fertig',
		DuplicatesFound: 'Doppelte Einträge gefunden:',
		DuplicateSitesFound: 'Doppelte Seitennamen gefunden:',
		Edit: 'Bearbeiten',
		EditDatasource: 'Datenquelle bearbeiten',
		EditDatasourceDescription: 'Felder für diese Datenquelle hinzufügen, löschen oder bearbeiten.\nDie hier gezeigten Felder zeigen die Zuordnung zwischen einem Datenquellenwert und einem SharePoint-Metadatenfeld.',
		EditDetails: 'Details bearbeiten',
		Empty: 'Leer',
		EmailHeaderMapping: 'E-Mail-Header-Zuordnung',
		Enable: 'Aktivieren',
		Enabled: 'Aktiviert',
		EnableApprovals: 'Genehmigungscenter aktivieren',
		EnableCopyMoveTo: 'Kopieren/Verschieben zu aktivieren',
		EnablePermissionManagent: 'Verwaltung von Website-/Bibliotheksberechtigungen aktivieren',
		EnablePII: 'PII aktivieren',
		EnablePIIRedaction: 'Schwärzung aktivieren',
		EnableNewTemplateFilters: 'Neue Vorlagenfilter aktivieren',
		EnableQuickFilter: 'Schnellfilter aktivieren',
		EnableSharing: 'Freigabe aktivieren',
		EnterAuthKey: 'Authentifizierungsschlüssel eingeben',
		EnterAuthSecret: 'Authentifizierungsgeheimnis eingeben',
		EnterNewLibName: 'Neuen Bibliotheksnamen eingeben',
		EnterNewSiteName: 'Neuen Seitennamen eingeben',
		EnterSharepointColumn: 'SharePoint-Spaltenname eingeben',
		EnterUrl: 'URL eingeben',
		Error: 'Fehler',
		ErrorAddingDatasourceMappedField: 'Fehler beim Hinzufügen des zugeordneten Feldes. Bitte versuchen Sie es erneut.',
		Evaluation: 'Bewertung',
		ExchangeSettings: 'Exchange-Einstellungen',
		Expired: 'Abgelaufen',
		ExpiryDate: 'Ablaufdatum',
		ExportToExcel: 'Nach Excel exportieren',
		Field: 'Feld',
		Fields: 'Felder',
		FieldName: 'Feldname',
		FieldToDisplay: 'Anzuzeigendes Feld eingeben',
		FieldShown: '{number} {fieldOrSite} angezeigt',
		FieldsShown: '{number} {fieldOrSite} angezeigt',
		FieldHidden: '{number} {fieldOrSite} ausgeblendet',
		FieldsHidden: '{number} {fieldOrSite} ausgeblendet',
		File: 'Datei',
		Filter: 'Filter',
		FilterDateStepSince: "Seit",
		FilterDateStepLast3Months: "In den letzten 3 Monaten",
		FilterDateStepLast30Days: "In den letzten 30 Tagen",
		FilterDateStepLast7Days: "In den letzten 7 Tagen",
		FilterDateStepSinceYesterday: "Seit gestern",
		FilterDateStepToday: "Heute",
		FilterDateStepTomorrow: "Morgen",
		FilterDateStepIn7Days: "In 7 Tagen",
		FilterDateStepIn30Days: "In 30 Tagen",
		FilterDateStepIn3Months: "In 3 Monaten",
		FilterDateStepInAYearOrMore: "In einem Jahr oder mehr",
		FilterSettings: 'Filtereinstellungen',
		FilterUsers: 'Benutzer filtern',
		FilterTenants: 'Mandanten filtern',
		Folder: 'Ordner',
		Free: 'Kostenlos',
		Frequency: 'Frequenz',
		FriendlyName: 'Anzeigename',
		From: 'Von',
		GeneralSettings: "Allgemeine Einstellungen",
		Hidden: 'Versteckt',
		HideAutoPreview: 'Automatische Vorschau ausblenden',
		HideDocumentLibrariesInTeams: "Dokumentbibliotheken von Teams-Websites ausblenden",
		HideTeamsSitesInSharePoint: "Teams-Websites in SharePoint ausblenden",
		HideTitleFieldFilter: "Titel-Feldfilter ausblenden",
		Importance: 'Wichtigkeit',
		Inactive: 'Inaktiv',
		InfoTypesSelected: 'Informationstypen ausgewählt',
		InReplyTo: 'Antwort auf',
		InsideDocumentLibrary: 'Innerhalb der Dokumentbibliothek',
		InsideFolder: 'Innerhalb des Ordners',
		InsideDocumentSet: 'Innerhalb des Dokumentensets',
		Integrations: "Integrationen",
		InvalidUrl: "Ungültiger URL-Wert",
		Invoice: 'Rechnung',
		InvoiceStatic: 'Rechnung',
		InvoiceDynamic: 'Rechnung dynamisch',
		Manage: 'Verwalten',
		ManageAdvancedSearchFields: 'Erweiterte Suchfelder verwalten',
		ManageDatasources: 'Mandanten-Datenquellen verwalten',
		ManageTeamsFields: 'Teams verwalten',
		ManageSites: 'Websites verwalten',
		ManageSitesPanelInfo: 'Websites hinzufügen, entfernen oder bearbeiten',
		ManageLibraries: 'Bibliotheken verwalten',
		ManageMetaData: 'Metadatenfelder zum Ausblenden verwalten',
		ManagedTenants: 'Verwaltete Mandanten',
		ManageSubscription: 'Abonnement verwalten',
		MappedFields: 'Zugeordnete Felder',
		MessageId: 'Nachrichten-ID',
		MetadataColorsEdit: "Metadatenfarben bearbeiten",
		MetaDataColorPicker: "Metadaten-Farbauswahl",
		MetadataColorValues: "Metadaten-Farbwerte",
		MetaDataSettings: 'Metadateneinstellungen',
		MetaDataValue: "Metadatenwert",
		Method: "Methode",
		MinimumVersionLimit: 'Mindestversionsgrenze',
		MinimumLicenseCharge: "Mindestens {amount} Lizenzen werden berechnet",
		Monthly: 'Monatlich',
		Multiselect: 'Mehrfachauswahl',
		Name: 'Name',
		New: 'Neu',
		NewTemplateSettings: 'Neue Vorlageneinstellungen',
		None: 'Keine',
		No: 'Nein',
		NoAcceptedRequests: 'Keine akzeptierten Anfragen',
		NoActivityFound: 'Keine Aktivitaet gefunden',
		NoEmptyFields: 'Leere Felder ausfüllen',
		NoFiltersAvailable: "Keine Filter verfügbar",
		NoOptionsAvailable: 'Keine Optionen verfügbar',
		NoPartner: 'Kein Partner zugewiesen',
		NoProduct: 'Kein Produkt',
		NoPendingRequests: 'Keine ausstehenden Anfragen',
		NoRejectedRequests: 'Keine abgelehnten Anfragen',
		NoRoleAssigned: 'Keine Rolle zugewiesen',
		NoTenantAdmins: 'Keine Mandanten-Administratoren',
		NoTenants: 'Keine verwalteten Mandanten',
		NoPartnerUsers: 'Keine Partnerbenutzer',
		NoSubscriptionsFound: "Keine Abonnements gefunden",
		NoSubscriptionsInView: "Keine Abonnements in dieser Ansicht",
		NoTenantSelected: 'Kein Mandant ausgewählt',
		NotEnoughLicensesAvailable: 'Nicht genügend Lizenzen verfügbar. {needed} Benutzer benötigen eine Lizenz, aber nur {available} sind verfügbar.',
		NumberOfUsers: 'Anzahl der Benutzer',
		OcrSettings: 'OCR-Einstellungen',
		OcrLanguage: 'OCR-Sprache',
		Ok: 'Ok',
		OnceOff: 'Einmalig',
		OpenDocumentsInClientApp: 'Dokumente in der Clientanwendung öffnen',
		OriginalSubject: 'Originalbetreff',
		OutlookSettings: 'Outlook-Einstellungen',
		Overview: 'Übersicht',
		OverwriteUserEmailMappings: "Möchten Sie alle Benutzer-E-Mail-Zuordnungen überschreiben?",
		OverwriteUsers: "Benutzer überschreiben",
		LandingPage: "Startseite",
		LastActivity: 'Letzte Aktivität',
		LastActivityNone: '-',
		LibraryPanelSubtitle: 'Bibliotheken hinzufügen, entfernen oder bearbeiten',
		LicenseExpiryDate: 'Ablaufdatum der Lizenz',
		LicenseType: 'Lizenztyp',
		LicenseCount: 'Lizenzanzahl',
		ListName: 'Listenname',
		LoadingPortal: 'Docubird-Portal wird geladen...',
		LoadingFilters: "Filter werden geladen",
		Paid: 'Bezahlt',
		Payments: 'Zahlungen',
		PaymentMethod: 'Zahlungsmethode',
		PaymentPlatform: 'Zahlungsplattform',
		Partner: 'Partner',
		Partners: 'Partner',
		PartnerUsers: 'Partnerbenutzer',
		Pending: 'Ausstehend',
		PermissionSettings: 'Berechtigungseinstellungen',
		PIISettings: 'PII-Einstellungen',
		PickColor: 'Farbe auswählen',
		Product: 'Produkt',
		ProductType: 'Produkttyp',
		Profile: 'Profil',
		PricePerLicenseMonth: "Monatlich - €{price}/Benutzer/Monat",
		PricePerLicenseYear: "Jährlich - €{price}/Benutzer/Monat",
		Received: 'Empfangen',
		References: 'Referenzen',
		Refresh: 'Aktualisieren',
		Regenerate: 'Erneuern',
		RegenerateApiKeyWarning: 'Möchten Sie wirklich einen neuen API-Schlüssel erstellen? Diese Aktion ist irreversibel.',
		Remove: 'Entfernen',
		Rejected: 'Abgelehnt',
		ReplyTo: 'Antwort an',
		RequiredMetadataOnPublish: 'Erforderliche Metadaten bei Veröffentlichung',
		Requests: 'Anfragen',
		RequestDate: 'Anfragedatum',
		RequestTenant: 'Mandant anfragen',
		RequestingPartner: 'Anfragender Partner',
		Reset: "Zurücksetzen",
		RestrictToLibraries: 'Auf Bibliotheken/Listen beschränken, z.B. list1; list2',
		RestrictToSites: 'Auf Websites beschränken, z.B. site1; site2',
		Resume: 'Fortsetzen',
		RevokeLicenses: 'Lizenzen widerrufen',
		Role: 'Rolle',
		Save: 'Speichern',
		SaveChanges: 'Änderungen speichern',
		SaveOnSend: 'Beim Senden speichern',
		SaveRequest: 'Anfrage speichern',
		Search: 'Suchen',
		SearchSectionFilter: "Filter {section} durchsuchen",
		SelectDatasourceField: 'Datenquellenfeld auswählen',
		SelectDatasourceType: 'Datenquellentyp auswählen',
		SelectPartner: 'Wählen Sie einen Partner zur Verwaltung dieses Mandanten aus',
		SelectTenantAdmin: 'Mandantenadministratoren auswählen',
		SelectTenant: 'Mandant auswählen',
		SetAsPartner: 'Benutzer als Partner festlegen',
		SelectPiiInfoTypes: 'PII-Informationstypen auswählen',
		SelectSpecificDates: "Bestimmte Daten auswählen",
		SelectSubscription: "Abonnement auswählen",
		Selected: 'ausgewählt',
		SelectPaymentMethod: 'Zahlungsmethode auswählen',
		SelectWebHookTopic: 'Service/Topic auswählen',
		SetAsTenantAdmin: 'Benutzer als Mandantenadministrator festlegen',
		Show: 'Anzeigen',
		ShowDateRangeSlider: "Datumsbereich-Schieberegler anzeigen",
		ShowLess: "Weniger anzeigen",
		ShowMore: "Mehr anzeigen",
		ShowAllFields: 'Alle Felder anzeigen',
		ShowAllTeams: 'Alle Teams anzeigen',
		ShowAllSites: 'Alle Websites anzeigen',
		ShowAllMetadata: 'Alle Metadatenfelder anzeigen',
		ShowAllTemplates: 'Alle Vorlagen anzeigen',
		ShowAll: 'Alle anzeigen',
		ShowSelected: 'Ausgewählte anzeigen',
		SignInDifferentAccount: 'Mit einem anderen Konto anmelden',
		SignInRequest: 'Anmeldeanforderung wird verarbeitet...',
		SignedInUser: 'Angemeldeter Benutzer: ',
		SignedOutMessage: 'Sie haben sich erfolgreich vom Docubird-Portal abgemeldet.',
		SignOut: 'Abmelden',
		Site: 'Website',
		Sites: 'Websites',
		SitesLibrariesConfigured: '{siteCount} Websites, {libraryCount} Bibliotheken konfiguriert',
		SiteName: 'Website-Name',
		SiteSettings: 'Website-Einstellungen',
		SiteUrl: 'Website-URL',
		SharepointColumnName: 'SharePoint-Spaltenname(n) z.B. col1, col2',
		Status: 'Status',
		Subject: 'Betreff',
		Subscription: 'Abonnement',
		SubscriptionAssignmentFailed: 'Die Abonnementzuweisung konnte nicht gespeichert werden. Bitte aktualisieren Sie die Seite und versuchen Sie es erneut.',
		Subscriptions: 'Abonnements',
		SubscriptionTier: 'Abonnementstufe',
		SubscriptionType: 'Abonnementtyp',
		SubscriptionUnavailable: 'Dieses Abonnement ist nicht mehr für die Zuweisung verfügbar.',
		SubscriptionViewAll: 'Alle',
		SubscriptionViewArchived: 'Archiviert',
		SubscriptionViewCurrent: 'Aktuell',
		Success: 'Erfolg',
		Suspend: 'Aussetzen',
		TeamName: 'Teamname',
		TeamSettings: 'Teameinstellungen',
		Tenant: 'Mandant',
		Tenants: 'Mandanten',
		TenantAdmin: 'Mandantenadministrator',
		TenantId: 'Mandanten-ID',
		TenantRequestSuccess: 'Mandantenverwaltung erfolgreich angefordert',
		Title: 'Titel',
		TitleRequired: 'Titel erforderlich',
		To: 'An',
		TotalRegistrations: 'Gesamtanzahl der Registrierungen',
		TryAgain: 'Erneut versuchen',
		Type: 'Typ',
		Unassigned: "Nicht zugewiesen",
		UnauthorizedMessage: 'Sie sind nicht berechtigt, auf das Docubird-Portal zuzugreifen.',
		Unlimited: 'Unbegrenzt',
		ServiceAddOn: 'Service-Add-on',
		ServiceProductNotAssignable: 'Service-Add-ons können Benutzern nicht zugewiesen werden.',
		Url: 'URL',
		User: 'Benutzer',
		UserActivity: 'Benutzeraktivität',
		Username: 'Benutzername',
		Users: 'Benutzer',
		VersionSettings: 'Versions-Einstellungen',
		WebHookTopic: "Service/Topic abonnieren",
		WebHookEventProcessEndpoint: "Prozessendpunkt (URL)",
		Yearly: 'Jährlich',
		Yes: 'Ja',
		CancelSubscription: 'Abonnement kündigen',
		CancelSubscriptionConfirmTitle: 'Abonnement kündigen?',
		CancelSubscriptionConfirmMessage: 'Möchten Sie das/die ausgewählte(n) Abonnement(s) wirklich kündigen?',
		CancelStripeSubscriptionMessage: 'Dieses Stripe-Abonnement bleibt bis zum {expiry} aktiv. Danach wird es nicht verlängert und der Zugriff endet. Zugewiesene Benutzer behalten den Zugriff bis zum Ende des Zeitraums. Sie können das Abonnement vorher über das Stripe-Kundenportal erneut abschließen.',
		CurrentPeriodEnd: 'das Ende des aktuellen Zeitraums',
		ReactivateSubscription: 'Abonnement reaktivieren',
		ReactivateSubscriptionConfirmTitle: 'Abonnement reaktivieren?',
		ReactivateStripeSubscriptionMessage: 'Dieses Abonnement ist für die Kündigung am {expiry} vorgemerkt. Durch die Reaktivierung wird die geplante Kündigung aufgehoben und das Abonnement wird normal verlängert.',
		ChangeQuantity: 'Anzahl ändern',
		ChangeQuantityDescription: 'Aktualisieren Sie die Anzahl der Lizenzen für dieses Abonnement. Aktuelle Anzahl: {current}.',
		NewSeatCount: 'Neue Lizenzanzahl',
		QuantityMustBePositive: 'Die Anzahl muss eine ganze Zahl von mindestens 1 sein.',
		QuantityChangeSubmitted: 'Die Anzahländerung wurde übermittelt. Die Lizenzanzahl wird aktualisiert, sobald Stripe bestätigt.',
		ProrateImmediately: 'Die anteilige Differenz jetzt berechnen',
		ProrateImmediatelyDescription: 'Wenn deaktiviert, wird die Änderung erst bei der nächsten Verlängerung angewendet.',
		ManageInStripe: 'In Stripe verwalten',
		Close: 'Schließen',
		PendingStripeConfirmation: 'Ausstehend: {count}',
		PendingStripeConfirmationTooltip: 'Stripe-Anzahländerung übermittelt. Die Lizenzanzahl wird aktualisiert, sobald Stripe bestätigt (normalerweise innerhalb weniger Sekunden).',
		DuplicateActiveSubscriptionWarning: 'Dieser Mandant hat bereits ein aktives Abonnement für das ausgewählte Produkt. Fortfahren erstellt ein zweites, unabhängiges Abonnement mit eigenem Abrechnungszyklus. Klicken Sie auf Abonnement hinzufügen, um zu bestätigen.',
		UnexpectedError: 'Ein unerwarteter Fehler ist aufgetreten. Bitte versuchen Sie es erneut.',
		CurrentlyAssignedUsers: 'Aktuell zugewiesen: {count} Benutzer',
		QuantityNoChangeMessage: 'Keine Anzahländerung ausgewählt. Abrechnung und Zuweisungen bleiben unverändert.',
		AutoRevokeMessage: '{count} Benutzer mit der ältesten Aktivität werden automatisch von diesem Abonnement entfernt, sobald Stripe bestätigt.',
		NoUsersRevokedMessage: 'Es werden keine Benutzer entfernt — die neue Lizenzanzahl deckt weiterhin alle zugewiesenen Benutzer ab.',
		AutoAssignMessage: 'Bis zu {count} neue Lizenz(en) werden automatisch den zuletzt aktiven berechtigten Benutzern in diesem Mandanten zugewiesen, sobald Stripe bestätigt.',
		PreviewLoading: 'Geschätzte Kosten werden berechnet…',
		PreviewUnavailable: 'Kostenschätzung ist derzeit nicht verfügbar.',
		PreviewCurrentInvoice: 'Aktuelle anstehende Rechnungssumme: {amount}',
		PreviewProrationDelta: 'Anteilige Belastung jetzt: {amount}',
		PreviewProrationCredit: 'Anteilige Gutschrift jetzt: {amount}',
		PreviewProrationNone: 'Keine anteilige Belastung — die Änderung wird bei der nächsten Verlängerung wirksam.',
		PreviewUpcomingInvoice: 'Anstehende Rechnungssumme: {amount}',
		SubscriptionHistory: 'Abonnementverlauf',
		NoSubscriptionHistory: 'Noch kein Verlauf vorhanden.',
		SubscriptionHistoryLoadFailed: 'Verlauf konnte nicht geladen werden.',
		SubscriptionPayments: 'Abonnementzahlungen',
		NoSubscriptionPayments: 'Noch keine Zahlungen.',
		SubscriptionPaymentsLoadFailed: 'Zahlungen konnten nicht geladen werden.',
		ViewInvoice: 'Rechnung ansehen',
		DownloadInvoicePdf: 'PDF herunterladen',
		LoadMore: 'Mehr laden',
		Loading: 'Wird geladen...',
		HideDetails: 'Details ausblenden',
		ShowDetails: 'Details anzeigen',
		OldValues: 'Alt',
		NewValues: 'Neu',
		Details: 'Details',
		OrphanCustomers: 'Verwaiste Kunden',
		OrphanCustomersDescription: 'Stripe-Kunden, deren Webhook-Ereignisse keinem Docubird-Mandanten zugeordnet werden konnten. Adoptieren Sie sie, um Metadaten zu stempeln und die hängenden Ereignisse erneut zu verarbeiten.',
		NoOrphans: 'Keine verwaisten Kunden — die Webhook-Mandantenauflösung ist gesund.',
		AdoptCustomer: 'Kunden adoptieren',
		AdoptOrphanCustomerTitle: 'Verwaisten Kunden adoptieren',
		PickTenant: 'Mandant auswählen',
		PickTenantPlaceholder: 'Wählen Sie den Mandanten, zu dem dieser Kunde gehört',
		AdoptOrphanWarning: 'Damit wird tenantGuid auf den Stripe-Kunden und seine Abonnements gestempelt und anschließend werden die hängenden Webhook-Ereignisse erneut verarbeitet. Stellen Sie sicher, dass die E-Mail-Adresse und die Produktliste zum gewählten Mandanten passen.',
		AdoptAndReprocess: 'Adoptieren & erneut verarbeiten',
		OrphanAdopted: 'Kunde adoptiert. Die hängenden Ereignisse wurden erneut eingereiht.',
		StuckEvents: 'Hängende Ereignisse',
		StuckSubscriptions: 'Stripe-Abonnements',
		CustomerDeleted: 'Kunde wurde in Stripe gelöscht',
		HasTenantGuidStamped: 'Hat bereits tenantGuid-Metadaten',
		StripeCustomerId: 'Stripe-Kunden-ID',
		StripeSubscriptionId: 'Stripe-Abonnement-ID',
		OldestEvent: 'Ältestes Ereignis',
		TotalAmount: 'Gesamtbetrag',
		UnresolvedDeadLetteredEvents: 'Ungelöste dead-lettered Ereignisse (kein Kundenbezug)',
		OrphanToolbarButton: 'Verwaiste',
		OrphanBannerSingular: 'Ein Stripe-Kunde konnte keinem Docubird-Mandanten zugeordnet werden.',
		OrphanBannerPlural: '{count} Stripe-Kunden konnten keinem Docubird-Mandanten zugeordnet werden.',
		Review: 'Prüfen',
		CancelsOn: 'Endet {date}',
		ManageStripeProducts: 'Stripe-Produkte verwalten',
		AddProduct: 'Produkt hinzufügen',
		EditProduct: 'Produkt bearbeiten',
		SyncFromStripe: 'Aus Stripe synchronisieren',
	}
};

export const LanguageContext = React.createContext(locales.en);

export class LocalizationModule {
	static getLocaleStrings() {
		const localeLang = navigator.language?.toLowerCase()?.substring(0, 2) ?? "";
		switch (localeLang) {
			case "en":
				return locales.en;
			case "nl":
				return locales.nl;
			case "de":
				return locales.de;
			default:
				return locales.en;
		}
	}
}
